import { taskIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const claimAndStartTask = {
  name: "claimAndStartTask" as const,
  input: z.object({ taskId: taskIdFormat.schema }),
  output: z.object({ redirectUrl: z.string() }),
};
